"use client";

import { useRouter } from "next/navigation";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";

export const QuotaButton = () => {
  const router = useRouter();
  const { t, lang } = useLang();
  return (
    <div className="grid grid-cols-2 gap-5 pl-16">
      <Button
        onClick={() => router.push(`/${lang}${links.stockMiningPricing}`)}
        className="col-start-2"
      >
        {t.winwingpt.sessions.getQuota}
      </Button>
    </div>
  );
};
